export const NgDocDeclarations = [
	'Class',
	'Interface',
	'Enum',
	'Function',
	'TypeAlias',
	'Variable',
] as const;
